class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open(itemId) {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
    document.body.classList.add('overflow-hidden');
    document.querySelector('.notification-drawer').classList.add('animate', 'active');
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
    document.querySelector('.notification-drawer').classList.remove('animate', 'active');
    document.body.classList.remove('overflow-hidden');
    const cartNotification = document.querySelector('#cart-notification');
    if (cartNotification.classList.contains('active-full')) {
      setTimeout(() => {
        cartNotification.classList.remove('active-full');
        cartNotification.style.transform = 'translateY(25%)'; // Forzamos el CSS
      }, 250)
    }
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    console.log('this.cartItemKey', this.cartItemKey)
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    this.generateRecommended(parsedState);
    if (this.header) this.header.reveal();
    this.open(parsedState.key);
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  generateRecommended(item_id) {
    console.log('item_id', item_id)
    // const parameters = `recommendations/products.json?product_id=${item_id.product_id}&section_id=related-products`
    // fetch(window.Shopify.routes.root + parameters)
    //   .then((response) => response.text())
    //   .then((text) => {
    //       console.log('text', text)
    //       const html = document.createElement('div');
    //       html.innerHTML = text;
    //       const recommendations = html.querySelector('product-recommendations');

    //       if (recommendations?.innerHTML.trim().length) {
    //         document.querySelector('#notification-products-recommended').innerHTML = recommendations.innerHTML;
    //       }

    //       if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
    //         this.remove();
    //       }

    //       if (html.querySelector('.grid__item')) {
    //         this.classList.add('product-recommendations--loaded');
    //       }

    //       productCardsSizes();
    //     }
    // );
  };

  handleBodyClick(evt) {
    const target = evt.target;
    console.log('target', target)
    if (target.nodeName == "CART-NOTIFICATION" || target.className == 'cart-notification-wrapper') {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
